export default __webpack_public_path__ + "static/art01-396cfe4286ef586640721cf6630c9768.jpeg";